// /src/pages/LegalPage.jsx

import React from 'react';
import PublicLexicalPage from '../components/PublicLexicalPage';

function LegalPage() {
  const documentName = 'Legal';
  return <PublicLexicalPage documentName={documentName} />;
}

export default LegalPage;
